import { useContext } from 'react';
import { ToastContext } from '../../components/ui/ToastContext';

/**
 * Hook to trigger toast notifications from anywhere in the app.
 *
 * @example
 * const toast = useToast();
 *
 * // Object form
 * toast({ variant: 'success', title: 'Product saved', description: 'Optional details' });
 *
 * // Shorthand form
 * toast.success('Product saved');
 * toast.error('Failed to save');
 * toast.warning('Low stock');
 * toast.info('Sync complete');
 */
export function useToast() {
  const toast = useContext(ToastContext);
  if (!toast) {
    throw new Error('useToast must be used within a <ToastProvider>');
  }
  return toast;
}
